import CloseIcon from "assets/images/CloseIcon";
import classNames from "classnames";
import {useState, useEffect} from "react";
import ReactModal from "react-modal";
import {common as stringsCommon, timePickerModal as strings} from "strings";

import Button from "components/Button";
import LoadingIndicator from "components/LoadingIndicator";
import TimePicker from "components/TimePicker/TimePicker";

import * as models from "liberty-core/api/models";

import styles from "./TimePickerModal.module.css";

type TimePickerModalProps = {
  visible: boolean;
  onClickConfirm: (timeChosen: models.TimeString) => void;
  onClickCancel: () => void;
  timePicked?: models.TimeString;
  allTimes: models.TimeString[];
  availableTimes: models.TimeString[];
  isLoading?: boolean;
};

export default function TimePickerModal({
  timePicked = "",
  ...props
}: TimePickerModalProps) {
  const [selectedTime, setSelectedTime] = useState(timePicked);

  useEffect(() => {
    setSelectedTime(timePicked);
  }, [timePicked, props.visible]);

  return (
    <ReactModal
      className={styles.modal}
      overlayClassName={styles.overlay}
      isOpen={props.visible}
    >
      <div className={styles.modalContent}>
        <button
          className={styles.close}
          onClick={() => {
            return props.onClickCancel();
          }}
        >
          <CloseIcon />
        </button>
        {props.isLoading ? (
          <LoadingIndicator className={styles.loadingIndicator} />
        ) : null}
        <div
          className={classNames(
            styles.timePickerContainer,
            props.isLoading && styles.hidden,
          )}
        >
          <TimePicker
            className={styles.timePicker}
            allTimes={props.allTimes}
            availableTimes={props.availableTimes}
            selectedTime={selectedTime}
            onClick={(time: models.TimeString) => setSelectedTime(time)}
          />
          <Button
            className={styles.bottomButtons}
            disabled={selectedTime === ""}
            onClick={() => {
              props.onClickConfirm(selectedTime);
            }}
          >
            {strings.select}
          </Button>
          <Button
            className={classNames(styles.closeButton, styles.bottomButtons)}
            variant="minimal"
            onClick={props.onClickCancel}
          >
            {stringsCommon.close}
          </Button>
        </div>
      </div>
    </ReactModal>
  );
}
